import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    height: theme.spacing(7),
    paddingRight: theme.spacing(10),
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(12),
    },
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.lighter,
        boxShadow: theme.shadows[2],
        zIndex: theme.zIndex.mobileStepper,
      },
    },
  },
  item: {
    '&:hover $addButton': {
      display: 'block',
    },
  },
  itemCheckboxWrapper: {
    minWidth: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(7),
    },
  },
  itemCheckbox: {
    [theme.breakpoints.up('sm')]: {
      margin: 0,
    },
  },
  itemText: {
    color: theme.palette.primary.main,
  },
  primary: {
    '.MuiListItem-button &': {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },
  itemButton: {
    cursor: 'default',
  },
  itemIcon: {
    fontSize: '1rem',
  },
  itemIconBig: {
    fontSize: '1.5rem',
  },
  iconGold: {
    color: theme.palette.secondary.dark,
  },
  iconGrey: {
    color: fade(theme.palette.grey[200], 0.6),
  },
  iconLight: {
    color: theme.palette.primary.light,
  },
  iconMain: {
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
  iconSuccess: {
    color: theme.palette.success.dark,
  },
  itemActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minWidth: theme.spacing(10),
    right: theme.spacing(3),
    zIndex: theme.zIndex.speedDial,
    '& > .MuiButtonBase-root': {
      width: theme.spacing(6),
      height: theme.spacing(6),
      '& + .MuiButtonBase-root': {
        marginLeft: theme.spacing(1),
      },
    },
  },
  addButton: {
    order: -1,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      order: 'inherit',
      display: 'none',
    },
  },
}))

export default useStyles
